import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { InfoGuide } from 'services/api/entities';
import ArticleImage from '../../components/GuideArticle/ArticleImage';
import Tips from '../../components/GuideArticle/Tips';

type PanelProps = {
  children: React.ReactNode;
  value: number | null;
  index: number;
};

const Panel = ({ children, value, index, ...other }: PanelProps) => {
  const theme = useTheme();

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`article-tabpanel-${index}`}
      aria-labelledby={`article-tab-${index}`}
      {...other}
      sx={{
        overflowY: 'auto',
        pb: theme.spacing(3),
      }}
    >
      {value === index && <Box sx={{ p: theme.spacing(3) }}>{children}</Box>}
    </Box>
  );
};

type PropsType = {
  article: InfoGuide;
  value: number | null;
};

const ArticlePanel = ({ article, value }: PropsType) => {
  const theme = useTheme();

  return (
    <Panel
      value={value}
      index={article.index}
      data-testid="ai-music-generator:mobile:article-panel"
    >
      <Typography variant="h4" sx={{ mb: theme.spacing(3), fontSize: 24 }}>
        {article.title}
      </Typography>
      {article?.primaryImage && (
        <ArticleImage
          imageOne={article.primaryImage}
          imageTwo={article.secondaryImage}
          altOne={article.altPrimary}
          altTwo={article.altSecondary}
        />
      )}
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{ __html: article.description }}
      />
      {article?.secondaryDescription && (
        <Typography
          variant="body1"
          mt={2}
          dangerouslySetInnerHTML={{ __html: article.secondaryDescription }}
        />
      )}
      {article?.tip && <Tips tip={article.tip} />}
    </Panel>
  );
};

export default ArticlePanel;
